var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMaletinEfectivo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 59.209,
    height: 54.98,
    viewBox: "0 0 59.209 54.98",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "maletin-efectivo",
    transform: "translate(-3 -2.992)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_31494",
    "data-name": "Trazado 31494",
    d: "M43.178,2.992V13.565H53.751V30.482a2.115,2.115,0,0,1-4.229,0V17.794H11.458a4.242,4.242,0,0,0-4.229,4.229v8.458H17.8a4.242,4.242,0,0,1,4.229-4.229H38.948v4.229a2.115,2.115,0,0,1-4.229,0H22.031v4.229a2.115,2.115,0,0,1,0,4.229H17.8V34.711H7.229v14.8h14.8a2.115,2.115,0,1,1,0,4.229H3V22.024a8.483,8.483,0,0,1,8.458-8.458h2.115V11.451a8.483,8.483,0,0,1,8.458-8.458ZM17.8,13.565H38.948V7.221H22.031A4.242,4.242,0,0,0,17.8,11.451Z",
    fill: "#00c1d4",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_31495",
    "data-name": "Trazado 31495",
    d: "M20.729,25.7A4.229,4.229,0,1,0,16.5,21.471,4.229,4.229,0,0,0,20.729,25.7Z",
    transform: "translate(24.563 25.928)",
    fill: "#00c1d4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_31496",
    "data-name": "Trazado 31496",
    d: "M41.6,14.992H16.229A4.242,4.242,0,0,0,12,19.221V31.909a4.242,4.242,0,0,0,4.229,4.229H41.6a4.242,4.242,0,0,0,4.229-4.229V19.221A4.242,4.242,0,0,0,41.6,14.992ZM20.458,31.909a4.242,4.242,0,0,0-4.229-4.229V23.451a4.242,4.242,0,0,0,4.229-4.229H37.375A4.242,4.242,0,0,0,41.6,23.451V27.68a4.242,4.242,0,0,0-4.229,4.229Z",
    transform: "translate(16.375 21.834)",
    fill: "#00c1d4",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaletinEfectivo);
export default __webpack_public_path__ + "static/media/maletin-efectivo.c3c1713a5b6a06811aaa0d8e67a497c5.svg";
export { ForwardRef as ReactComponent };